import { BsCheck, BsCheckAll } from "react-icons/bs";
import { FaRegTrashAlt } from "react-icons/fa";
import styles from "./ChatItem.module.scss";
import { useState } from "react";
import Loading from "../Loading";
//TODO BUG SEND MESSAGE AND NAVIGATE IN CURRENT MESSAGE ROOME
function ChatItem({
  senderName,
  sendDate,
  img,
  children,
  isSender,
  isRead,
  onRemove,
}) {
  const [isRemove, setisRemove] = useState(false)
  return (
    <div className={`${styles.item}  ${isSender == false ? styles.sender : ""}`}>
      <div className={styles.box + " position-relative"}>
        {isRemove ?
          <div className="w-100 d-flex justify-content-center align-items-center" style={{ position: "absolute", borderRadius: 15, top: "0", left: 0, backgroundColor: "rgb(0 0 0 / 55%);", width: "100%", height: "100%" }}>

            <div class="lds-ellipsis">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>

          </div>
          : null}
        <div className={styles.header}>
          <p className={styles.name}>{senderName || "بدون نام"}</p>
          <p className={styles.date}>{sendDate || "بدون تاریخ"}</p>
        </div>

        <div className={styles.body}>{children}
        </div>
        {isSender ? (
          <div className={styles.date}>
            {isRead ? (
              <BsCheckAll color="green" size={20} />
            ) : (
              <BsCheck color="green" size={20} />
            )}
          </div>
        ) : null}
        {isSender ? (
          <div className={styles.date} onClick={() => {
            setisRemove(true)
            onRemove()
          }}>
            <FaRegTrashAlt color="red" size={25} />
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default ChatItem;
